import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/OrganizationSettingsResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}`;
	}
	getAvailableStatementDetails() {
		return this.api.get(this.buildPath(`${n.baseUrl}/definition/statementdetails`));
	}
};
export { n as OrganizationSettingsResource };

//# sourceMappingURL=OrganizationSettingsResource.js.map